import { stringify } from "query-string"
import { dhFoodsMain } from "./api"

const endpoint = "/news"

export const getNewsList = async (queries = {}) => {
  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })
  const response = await dhFoodsMain.get(
    `${endpoint}${query ? `?${query}` : ""}`
  )

  return response.data
}

export const getNewsById = async (newsId) => {
  const response = await dhFoodsMain.get(`${endpoint}/${newsId}`)

  return response.data
}

export const createNews = async (data) => {
  const response = await dhFoodsMain.post(`${endpoint}`, data)

  return response.data
}

export const updateNews = async (newsId, data) => {
  const response = await dhFoodsMain.patch(`${endpoint}/${newsId}`, data)

  return response.data
}

export const deleteNews = async (newsId) => {
  const response = await dhFoodsMain.delete(`${endpoint}/${newsId}`)

  return response.data
}
